import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { HeaderComponent } from "./header.component";

@NgModule({
  declarations: [HeaderComponent],
  imports: [CommonModule, NgbCollapseModule],
  exports: [HeaderComponent]
})
export class HeaderModule {}
